import { startOfWeek, addDays } from 'date-fns';
import { DayType, DayObj } from '../type';
import * as fp from 'lodash/fp';

export default function dayListGenerator(
  { year, month }: { year: number; month: number },
  dayTypeRuleFn: (date: Date) => DayType,
): Array<DayObj> {
  const startDay = startOfWeek(new Date(year, month, 1));

  return fp.times((index) => {
    const date = addDays(startDay, index);

    return {
      date,
      year: date.getFullYear(),
      month: date.getMonth(),
      day: date.getDate(),
      dayType:
        fp.eq(year)(date.getFullYear()) && fp.eq(month)(date.getMonth())
          ? dayTypeRuleFn(date)
          : DayType.NONE,
    };
  })(42);
}
